import RouterComponent from './router/';
// import React, { Component } from 'react'

import './i18n';
import './App.css'


const App = () =>
(
  <>
    <RouterComponent />
  </>
)

export default App;
